import { FC } from 'react'
import { Icon } from '@iconify/react'
import { BooleanParam, useQueryParam } from 'use-query-params'
import { useModal } from '@ebay/nice-modal-react'

import { useGlobalState } from '@pepper/ui'

import AiSuggestedTopics from 'assets/images/ai_suggested_topics.png'
import TopicCreation from 'assets/images/topic_creation.png'
import TopicsUpload from 'assets/images/topics_upload.png'

import EmptyStateCard from 'components/EmptyStateCard'

import s from './EmptyState.module.css'

type Props = {
  onTopicResearch: () => void
  onImport: () => void
  isDomainRemoved?: boolean
  isDomainNotLinked?: boolean
}

export const EmptyState: FC<Props> = ({
  onImport,
  onTopicResearch,
  isDomainRemoved,
  isDomainNotLinked,
}) => {
  const { permissions } = useGlobalState()
  const { show } = useModal('buy-cmp')
  const [_, setOpenLinkDomainModal] = useQueryParam('link_domain', BooleanParam)

  const hasTopicsPermission = permissions?.topics

  const handleClick = (onClick: () => void) => {
    if (!hasTopicsPermission) {
      show({ id: 'keywords' })
    } else if (isDomainNotLinked && hasTopicsPermission) {
      setOpenLinkDomainModal(true)
    } else {
      onClick()
    }
  }

  return (
    <div className={s.wrapper}>
      <h4 className={s.title}>Your content topics appear here..</h4>
      {isDomainRemoved ? (
        <p className={s.error}>
          <Icon icon="lucide:info" />
          Domain associated with this project has been removed
        </p>
      ) : (
        <p className={s.subtitle}>
          Every great content journey begins with a single word. Let&apos;s get
          started! 👇
        </p>
      )}
      <div className={s.cardsWrapper}>
        <EmptyStateCard
          onClick={() => handleClick(onTopicResearch)}
          alt="AI suggested topics"
          image={AiSuggestedTopics}
          title="Discover Topics"
          description="Dive into a sea of content ideas curated for you, or create your very own! 💡"
          icon={<Icon width={22} icon="heroicons:sparkles-solid" />}
          disabled={isDomainRemoved}
          dataId="discover-topics-card"
        />

        <EmptyStateCard
          onClick={() => handleClick(onImport)}
          alt="topics import"
          image={TopicsUpload}
          title="Import your Topics"
          description="Have a list ready? 📋 Create keywords, SEO briefs, and start writing!"
          icon={<Icon icon="uil:file-upload-alt" width={22} />}
          disabled={isDomainRemoved}
        />
      </div>
    </div>
  )
}
